// extracted by mini-css-extract-plugin
export default {"box":"History_box__Zz6yL","empty":"History_empty__9b1o6"};